var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.device_type == 1)?_c('div',{attrs:{"id":"layout"}},[_c('Sliderbar'),_c('NavBar',{attrs:{"userInfo":_vm.USERINFO}}),_c('div',{staticClass:"appmain"},[_c('router-view')],1)],1):(_vm.device_type == 2)?_c('div',{attrs:{"id":"layout"}},[_c('Sliderbar'),_c('div',{staticClass:"appmain_mobile"},[_c('router-view')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }